import axios, {AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { API_URL } from "../constant";
import { UploadExcelResult} from "../constant";
  
export async function uploadexcel(data: FormData): Promise<UploadExcelResult> {
    try {
        const token = localStorage.getItem("token")
       
        const config: AxiosRequestConfig = {
            headers: {
              Authorization: `Bearer ${token}`, // Bearer token
              'Content-Type': 'multipart/form-data'
            },
          };
      
        const response: AxiosResponse  = await axios.post(
          `${API_URL}api/filing/bulk_upload`,
          data,
          config,
        );
    
        if (response.status === 200)
        {
            return { success: true, code: response.data.code, filings: response.data.records };
        }
        else{
            return { success: false, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, errorMsg: "No response received from server" };
        } else {
            return { success: false, errorMsg: `Error:, ${error.message}` };
        }
    }
}